import { useState } from 'react';
import { PrintReceiptInput, PrintReceiptUseCase } from '../../application/useCases';
import { useApp } from '../contexts';

type PrintOptions = Omit<PrintReceiptInput, 'supplierId' | 'token'>;

export const useReceiptPrint = (supplierId: number | null, token: string | null) => {
    const { showError } = useApp();
    const [printingId, setPrintingId] = useState<number | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const printReceipt = async (options: PrintOptions): Promise<boolean> => {
        setLoading(true);
        setPrintingId(options.transactionId ?? null);
        setError(null);
        try {
            await new PrintReceiptUseCase().execute({ ...options, supplierId, token });
            return true;
        } catch (err) {
            const message = err instanceof Error ? err.message : 'Erro ao gerar comprovante';
            setError(message);
            showError(message);
            return false;
        } finally {
            setLoading(false);
            setPrintingId(null);
        }
    };

    return { printReceipt, printingId, loading, error };
};
